<table mat-table [dataSource]="dataSource()" class="mat-elevation-z8">

  <mat-text-column name="serialNumber"></mat-text-column>

  <ng-container matColumnDef="traceNumber">
    <th mat-header-cell *matHeaderCellDef>Trace Number</th>
    <td mat-cell *matCellDef="let row" class="navigateTo" (click)="openUrl(row.traceUrl)">
      {{row.traceNumber}}
    </td>
  </ng-container>

  <ng-container matColumnDef="lastNdeDate">
    <th mat-header-cell *matHeaderCellDef> NDE </th>
    <td mat-cell *matCellDef="let row" class="navigateTo" (click)="openUrl(row.lastNde)">
      {{row.lastNdeDate | date:'shortDate'}}
    </td>
  </ng-container>

  <ng-container matColumnDef="ndeTimeAgo">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row" class="navigateTo" (click)="openUrl(row.lastNde)">
      {{row.lastNdeDate | timeAgo }}
    </td>
  </ng-container>

  <mat-text-column name="disPoNumber"></mat-text-column>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="$event.stopPropagation()">
  </tr>
</table>
